export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_64',
	providers: {
		paltaMap: {},
	},
	otp: {
		priceMap: {
			USD: 64,
		},
	},
}
